import React from "react";
import MapContainer from "./../containers/map_placeholder/MapContainer";
import SmartisCityMap from "./../components/map/SmartisCityMap";
// Αλεξανδρούπολη
// const cityCenter = {
//   lat: 40.8472598,
//   lng: 25.8847129,
// };

// Πρέβεζα - Κοινότητα
// const cityCenter = {
//   lat: 38.957364210005615,
//   lng: 20.754522551519024,
// };

// Δράμα
const cityCenter = {
  lat: 41.1480676,
  lng: 24.1250772,
};

// Ζίτσα
// const cityCenter = {
//   lat: 39.7533943,
//   lng: 20.6386958,
// };

const Map = (props) => {
  return (
    <MapContainer mapFrame={props.mapFrame ? props.mapFrame : null}>
      <SmartisCityMap cityCenter={cityCenter} />
    </MapContainer>
  );
};

export default Map;
